// src/pages/WritePost/index.js
import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  Input,
  Button,
  Space,
  message,
  Typography,
  DatePicker,
  Select,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { createPost, getPost, updatePost } from "../../api/mockData";

const { TextArea } = Input;

export default function WritePost() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const isEdit = !!id;

  useEffect(() => {
    if (!isEdit) return;
    setLoading(true);
    getPost(id)
      .then((post) => {
        if (!post) return;
        form.setFieldsValue({
          title: post.title,
          summary: post.summary,
          category: post.category,
          tags: post.tags || [],
          content: post.content,
          publishDate: post.createdAt ? dayjs(post.createdAt) : undefined,
        });
      })
      .finally(() => setLoading(false));
  }, [form, id, isEdit]);

  const onFinish = async (values) => {
    const tags = (values.tags || []).map((s) => String(s).trim()).filter(Boolean);

    const payload = {
      title: values.title,
      summary: values.summary || "",
      category: values.category || "",
      tags,
      content: values.content,
      createdAt: values.publishDate ? values.publishDate.valueOf() : undefined,
    };

    if (isEdit) {
      const post = await updatePost(id, payload);
      if (!post) {
        message.error("文章不存在，无法更新");
        return;
      }
      message.success("更新成功");
      navigate(`/post/${post.id}`);
      return;
    }

    const post = await createPost(payload);

    message.success("发布成功");
    navigate(`/post/${post.id}`);
  };

  return (
    <Card className="themed-card" bodyStyle={{ padding: "22px 26px" }}>
      <Typography.Title level={3} style={{ color: "var(--text-primary)" }}>
        {isEdit ? "编辑文章" : "写文章"}
      </Typography.Title>

      <Form layout="vertical" onFinish={onFinish} form={form} disabled={loading}>
        <Form.Item
          label="标题"
          name="title"
          rules={[{ required: true, message: "请输入标题" }]}
        >
          <Input placeholder="请输入文章标题" />
        </Form.Item>

        <Form.Item label="摘要" name="summary">
          <Input placeholder="用于列表页展示（可选）" />
        </Form.Item>

        <Form.Item label="分类" name="category">
          <Input placeholder="例如：前端 / 生活随笔" />
        </Form.Item>

        <Form.Item label="标签（可多选）" name="tags">
          <Select
            mode="tags"
            tokenSeparators={[",", "，"]}
            placeholder="例如：React, 前端, 随笔"
          />
        </Form.Item>

        <Form.Item label="补档日期" name="publishDate">
          <DatePicker
            showTime
            style={{ width: "100%" }}
            placeholder="选择补档日期（可选）"
          />
        </Form.Item>

        <Form.Item
          label="正文"
          name="content"
          rules={[{ required: true, message: "请输入正文" }]}
        >
          <TextArea rows={10} placeholder="请输入正文内容" />
        </Form.Item>

        <Space>
          <Button type="primary" htmlType="submit" className="themed-primary">
            {isEdit ? "保存修改" : "发布"}
          </Button>
          <Button onClick={() => navigate(-1)}>取消</Button>
        </Space>
      </Form>
    </Card>
  );
}
